const CART_SELECTORS = {
	cartQuantity: 'data-cart-quantity',
	cartTotal: 'data-cart-total'
}

/**
 * Get product variant ID from base 64 string
 * @param {string} string - base 64 encoded variant id
 * @return {string} product variant ID - returns decoded product variant ID
 */
export const productVariantFromBase64String = (string) => {
	const splitString = atob(string).split('/');
	return splitString[splitString.length - 1];
}

/**
 * Get base64 encoded ID from Product ID
 * @param {id} int - product id
 * @return {string} base64 encoded product ID for Shopify Graphql
 */
export const base64EncodeProductId = (id) => {
	const decodedString = `gid://shopify/Product/${id}`
	return btoa(decodedString);
}

export const formatMoney = (cents, format = "${{amount}}") => {
	console.log(cents)
	if (typeof cents == 'string') { cents = cents.replace('.', ''); }
	var value = '';
	var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	var formatString = (format || this.money_format);

	function defaultOption(opt, def) {
		return (typeof opt == 'undefined' ? def : opt);
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2);
		thousands = defaultOption(thousands, ',');
		decimal = defaultOption(decimal, '.');

		if (isNaN(number) || number == null) { return 0; }

		number = (number / 100.0).toFixed(precision);

		var parts = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			cents = parts[1] ? (decimal + parts[1]) : '';

		return dollars + cents;
	}

	switch (formatString.match(placeholderRegex)[1]) {
		case 'amount':
			value = formatWithDelimiters(cents, 2);
			break;
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0);
			break;
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',');
			break;
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',');
			break;
	}

	return formatString.replace(placeholderRegex, value);
}

export const removeLineItem = (key) => {
	return fetch('/cart/update.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest'
		},
		body: JSON.stringify({
			updates: {
				[key]: 0
			}

		})
	})
}

export const changeLineItem = async (line_item_key, quantity) => {
	const data = await fetch('/cart/change.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest'
		},
		body: JSON.stringify({
			id: line_item_key,
			quantity: quantity
		})
	})
	return await data.json()

}


export const addLineItem = async (key, quantity = 1, properties = {}, updateProductButton) => {
	const data = await fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest'
		},
		body: JSON.stringify({
			quantity: quantity,
			id: key,
			properties: properties
		})
	})
	const item = await data.json()
	const cart = await getCart();
	updateCartDisplay(cart);
	updateProductButton();
	return item;
}

export const getCart = async () => {
	const data = await fetch('/cart.js', {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest'
		}
	})
	return await data.json()
}

export const updateCartDisplay = (cart) => {
	document.querySelectorAll(`[${CART_SELECTORS.cartQuantity}]`).forEach(elem => {
		elem.innerHTML = cart.item_count
	})
	document.querySelectorAll(`[${CART_SELECTORS.cartTotal}]`).forEach(elem => {
		elem.innerHTML = formatMoney(cart.total_price)
	})
}








